import React, { useState, useEffect,Fragment } from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './EditLotShipmentModalComponent.css';
import edit_lot_base_image from '../../../src/assets/images/edit_lot_base_image.png';
import edit_lot from '../../../src/assets/images/edit_lot.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { updateShipmentProductLotQty, addShipmentProductLots, fetchStockById } from '../../redux/shipmentSlice'


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const UpdateCourierModalComponent = ({ isOpen, onClose, shipmentId, stock, shipmentProductId, shipmentProductLotId, updateLotCount }) => {
 
  const dispatch = useDispatch();
  const [courierQty, setcourierQty] = useState('');
  const [errors, setErrors] = useState('');

  const handleTextChange = (event) => {
    const { value } = event.target;
    const enteredQty = parseInt(value);
    setcourierQty(enteredQty);

    // const maxQty = stock?.productQty || 0;
    // if (!value.trim()) {
    //   setErrors('Quantity is required');
    // } else if (enteredQty < 1 || enteredQty > maxQty) {
    //   setErrors(`Invalid Quantity`);
    // } else {
    //   setErrors('');
    //   setcourierQty(enteredQty);
    // }
  };
  const handleSubmit = () => {
    // if (courierQty) {
    //   //  console.log('Text submitted:', courierQty,"shipmentProductLotId",shipmentProductLotId);
    //   //  console.log('stock.stockLotId:', stock.stockLotId,"shipmentProductId",shipmentProductId,"courierQty",courierQty);
    //   if (shipmentProductLotId) {
    //     dispatch(updateShipmentProductLotQty({ shipmentProductLotId, courierQty }));
    //   } else {
    //     dispatch(addShipmentProductLots({ shipmentProductId, stockLotId: stock.stockLotId, courierQty }))
    //   }
    //   updateLotCount();
    //   onClose(false);
    // }
  };

  const handleClose = () => {
    // setOpen(false);
    onClose(false);
  };

  return (
    <Fragment >
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        className='editLotshipmentDeclineModalBody'

      >
        <DialogTitle sx={{ m: 0, p: "0px 39px " }} id="customized-dialog-title">
          {/* Modal title */}
          <div className='editLotmodalImagediv'>
            <img
              className='modalImage1'
              src={edit_lot_base_image}
            />
            <img
              className='modalImage2'
              src={edit_lot}
            />
            <h4 className='headingForEditLotShipmentModal'> Update Courier Number </h4>
          </div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            <h4 className='titleHeadingForEditLotModal1'>Courier Number</h4>
            <div className='shipmentEditLotModalTextField'>
              <TextField
                label="Quantity"
                variant="outlined"
                fullWidth
                inputProps={{
                  style: {
                    height: "20px",
                  },
                }}
                value={courierQty}
                onChange={handleTextChange}
                margin="normal"
                type="number"
                required
                error={!!errors}
                helperText={errors}
              />
            </div>
          </Typography>

        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleSubmit} variant="contained" color="primary"
            style={{ width: "400px", marginRight: "19%", marginLeft: "20%", backgroundColor: "rgb(4 176 54)", textDecoration: "white" }}
          >
            Update
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </Fragment>
  );
}

export default UpdateCourierModalComponent;
